// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
const ReactRedux = require('react-redux')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const ErrorBoundary = require('client-v2/common/components/error-boundary')
const Router = require('client-v2/common/state/router/component')

// This propagates Redux and Router state down to child components
// The actual markup is represented in the layout component

module.exports = function (WrappedComponent) {
  function RootComponent(props) {
    return (
      tag(ErrorBoundary,
        tag(ReactRedux.Provider, { store: props.store },
          tag(Router,
            tag(WrappedComponent)
          )
        )
      )
    )
  }

  RootComponent.propTypes = {
    store: PropTypes.shape({
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired,
      subscribe: PropTypes.func.isRequired
    }).isRequired
  }

  RootComponent.factory = React.createFactory(RootComponent)

  return RootComponent
}
